import * as React from 'react';
import classnames from 'classnames';
import { Divider } from '@grandvisionhq/elements';
import { isNil } from '@grandvisionhq/utils';
import { useCartSlots } from '../../../slots/context.js';
import '../../../slots/footer-slot/context.js';
import '../../../slots/header-slot/context.js';
import '../../../slots/sidebar-slot/context.js';
import '@grandvisionhq/common';
import { MainTotal } from '../components/MainTotal.js';
import { PaymentMethodPrice } from '../components/PaymentMethodPrice.js';
import { Shipping } from '../components/Shipping.js';
import '@grandvisionhq/iris-ui';
import { ShippingThreshold } from '../components/ShippingThreshold.js';
import { PriceRow } from '../components/PriceRow.js';

const Regular = ({ className , currency , labels , prices , settings , freeShippingThreshold , isMiniCart , discountedPrice , numberOfItems  })=>{
    const { Slots  } = useCartSlots();
    const showShippingThreshold = (!settings.isReadOnly || isMiniCart) && !isNil(freeShippingThreshold) && !isNaN(freeShippingThreshold) && freeShippingThreshold > 0 ? true : false;
    // If shipping price is 0, show the message that the free shipping threshold is reached
    const showShippingThresholdReached = prices.shippingPrice === 0;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, showShippingThreshold && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ShippingThreshold, {
        price: discountedPrice || 0,
        labels: labels,
        freeShippingThreshold: showShippingThresholdReached ? 0 : freeShippingThreshold || 0
    }), /*#__PURE__*/ React.createElement(Divider, {
        className: "cart-totals__divider divider--light"
    })), /*#__PURE__*/ React.createElement("div", {
        role: "list",
        className: classnames('cart-totals', className),
        "data-t": "cart-totals"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "cart-totals__group"
    }, /*#__PURE__*/ React.createElement(PriceRow, {
        label: `${labels.totalItems} (${numberOfItems})`,
        currency: currency,
        price: prices.preDiscountPrice
    }), prices.discountPrice ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PriceRow, {
        label: labels.productDiscounts,
        currency: currency,
        price: -prices.discountPrice,
        isDiscount: true
    })) : null), prices.discountPrice ? /*#__PURE__*/ React.createElement(Divider, {
        className: "cart-totals__divider divider--light "
    }) : null, /*#__PURE__*/ React.createElement("div", {
        className: "cart-totals__group"
    }, prices.discountPrice ? settings.shouldShowSubTotal && /*#__PURE__*/ React.createElement(PriceRow, {
        label: labels.subTotal,
        currency: currency,
        price: prices.subTotalPrice,
        isEmphasized: true
    }) : null, prices.paymentMethodPrice && /*#__PURE__*/ React.createElement(PaymentMethodPrice, {
        label: labels.paymentMethodPrice,
        price: prices.paymentMethodPrice,
        currency: currency
    }), /*#__PURE__*/ React.createElement(Shipping, {
        labels: labels,
        price: prices.shippingPrice,
        currency: currency
    })), /*#__PURE__*/ React.createElement(Divider, {
        className: "cart-totals__divider divider--light"
    }), /*#__PURE__*/ React.createElement(MainTotal, {
        label: labels.total,
        price: prices.totalPrice,
        currency: currency
    }), Slots.AfterTotals ? /*#__PURE__*/ React.createElement(Slots.AfterTotals, null) : null));
};

export { Regular };
//# sourceMappingURL=Regular.js.map
